import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'

function MLUmbrellaCoverage({ period, getFormattedCurrency, show }) {
    const translator = useTranslator();

    if (_.isEmpty(period)) {
        return null;
    }

    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th>{translator(messages.Coverage)}</th>
                    <th>{translator(messages.Limits)}</th>
                    <th>{translator(messages.Premium)}</th>
                </tr>
            </thead>
        );
    }

    const generateCoverageTable = (coverages) => {
        if (!_.isEmpty(coverages)) {
            return (
                <div>
                    <tbody>
                        {coverages.map((coverage) => {
                            return (
                                <tr>
                                    <td><strong>{coverage.name}</strong></td>
                                    <td><strong>{coverage.terms[0].chosenTermValue}</strong></td>
                                    <td>{getFormattedCurrency(coverage.amount)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </div>
            );
        }
        return (<></>)
    }

    const generatePersonalAutoOrWatercraftCoveragesTable = () => {
        if (period.lobs_ML.personalUmbrella.prsnlAutoExcessCoverages || period.lobs_ML.personalUmbrella.prsnlWatercraftExcessCoverages) {
            return (
                <table className={cx('table table-striped', styles.tableStriped)}>
                    {generateHeader()}
                    {generateCoverageTable(period.lobs_ML.personalUmbrella.prsnlAutoExcessCoverages)}
                    {generateCoverageTable(period.lobs_ML.personalUmbrella.prsnlWatercraftExcessCoverages)}
                </table>
            );    
        }
        return (<></>);
    }

    const generateOptionalCoveragesTable = () => {
        if (!_.isEmpty(period.pupOptionalCoverages_ML)) {
            return (
                <table className={cx('table table-striped table-bordered', styles.tableStriped)}>
                    <tbody>
                        {period.pupOptionalCoverages_ML.map((coverage) => {
                            return (
                                <tr>
                                    <td className="col-md-3"><strong>{coverage.name}</strong></td>
                                    <td>
                                        {coverage.value.map((v) => {
                                            return (
                                                <div>{v}</div>
                                            );
                                        })}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            );
        }
        return (<></>);
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.OptionalCoverages)}
                </h2>
                {generatePersonalAutoOrWatercraftCoveragesTable()}
                {generateOptionalCoveragesTable()}
            </div>
        );
    }
    return ( <></> );
}

MLUmbrellaCoverage.propTypes = {
    data: PropTypes.shape([]),
    getFormattedCurrency: PropTypes.func.isRequired,
    show: PropTypes.bool
};
MLUmbrellaCoverage.defaultProps = {
    data: [],
    show: false
};
export default MLUmbrellaCoverage;
